import React from 'react';
import styled from 'styled-components';
import TeamWithLogo from '../TeamWithLogo';

/**
 * Renders "vs" or "@" plus team logo/name in a single non-wrapping unit so the prefix
 * stays aligned with the team when the Matchup column is narrow.
 */
const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
`;

function MatchupCell({ homeAway, opponentTeamId, opponent, size = 22 }) {
  const prefix = homeAway === 'home' ? 'vs' : '@';
  return (
    <Wrapper>
      <span>{prefix}</span>
      <TeamWithLogo teamId={opponentTeamId} teamName={opponent} size={size} />
    </Wrapper>
  );
}

export default MatchupCell;
